import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact-page fade-in">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p className="contact-subtitle">Get in touch about BeanBuzz Cafe Management System</p>
        </div>

        <div className="contact-content">
          <div className="contact-section">
            <h2>About BeanBuzz</h2>
            <p>
              BeanBuzz is a comprehensive cafe management system currently in active development. 
              Our platform is designed to revolutionize how cafes operate, from order management 
              to customer experience.
            </p>
            <div className="system-status">
              <div className="status-badge development">
                <span className="status-icon">🚧</span>
                <span>In Development</span>
              </div>
            </div>
          </div>

          <div className="contact-section">
            <h2>Interested in Our System?</h2>
            <p>
              We're looking for cafe owners and managers who are interested in:
            </p>
            <ul className="interest-list">
              <li>🚀 Early access to our cafe management platform</li>
              <li>🧪 Beta testing opportunities</li>
              <li>💡 Providing feedback and feature requests</li>
              <li>🤝 Partnership opportunities</li>
              <li>📊 Learning about our analytics and reporting features</li>
            </ul>
          </div>

          <div className="contact-section">
            <h2>Contact Information</h2>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="contact-icon">📧</div>
                <div className="contact-details">
                  <h3>Email</h3>
                  <a href="mailto:vadym@suprun.ca" className="contact-link">
                    vadym@suprun.ca
                  </a>
                  <p>Primary contact for all inquiries</p>
                </div>
              </div>
              
              <div className="contact-method">
                <div className="contact-icon">🌐</div>
                <div className="contact-details">
                  <h3>Demo Access</h3>
                  <a href="/beanbuzz-demo/dashboard" className="contact-link">
                    Try Our Demo
                  </a>
                  <p>Experience the system firsthand</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-section">
            <h2>What We Offer</h2>
            <div className="offerings-grid">
              <div className="offering-card">
                <h3>📱 Mobile-First Design</h3>
                <p>Optimized for tablets and smartphones used in cafe environments</p>
              </div>
              <div className="offering-card">
                <h3>🍽️ QR Code Ordering</h3>
                <p>Customers order directly from their table using QR codes</p>
              </div>
              <div className="offering-card">
                <h3>👨‍🍳 Kitchen Dashboard</h3>
                <p>Real-time order tracking and management for kitchen staff</p>
              </div>
              <div className="offering-card">
                <h3>📋 Menu Management</h3>
                <p>Easy interface for updating menu items, prices, and availability</p>
              </div>
              <div className="offering-card">
                <h3>📊 Analytics & Reporting</h3>
                <p>Track sales, popular items, and customer preferences</p>
              </div>
              <div className="offering-card">
                <h3>⚙️ Customization</h3>
                <p>Personalize branding, themes, and feature settings</p>
              </div>
            </div>
          </div>

          <div className="contact-section">
            <h2>Get Started</h2>
            <div className="cta-section">
              <p>
                Ready to learn more about how BeanBuzz can transform your cafe operations? 
                We'd love to hear from you and discuss how our system can benefit your business.
              </p>
              <div className="cta-buttons">
                <a href="mailto:vadym@suprun.ca" className="btn btn-primary btn-large">
                  📧 Contact Us
                </a>
                <Link to="/beanbuzz-demo/dashboard" className="btn btn-secondary btn-large">
                  🚀 Try Demo
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-footer">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Contact; 